import React from 'react';
import Waiting from '../Waiting';
import {Button} from 'rctui';
import I18n from '../I18n';

const FormRowSubmit = ({disabled, text, status}) => (
  <div className="form_row_submit">
    <Button status={status} type="submit" disabled={disabled}><I18n message={text}/></Button>
    <Waiting visible={disabled}/>
  </div>
);

FormRowSubmit.defaultProps = {
  disabled: false,
  text: "button.send"
};

FormRowSubmit.propTypes = {
  disabled: React.PropTypes.bool,
  text: React.PropTypes.string
};

export default FormRowSubmit;



// WEBPACK FOOTER //
// ./src/js/Component/Form/FormRowSubmit.jsx